import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Checkbox from "Components/Checkbox";
import { getUser } from "Utils/storage";
import Dropdown from "Components/Dropdown";
import { ReactComponent as Back } from "Icons/back-bordered.svg";
import { ReactComponent as Forward } from "Icons/forward-bordered.svg";
import DetailsPopup from 'Components/ApprovalDetailsPopup/index.jsx';
import moment from "moment";
//const onRFQTypeSelect;



export default class ApprovalMatrix extends Component {

  constructor(props){
    super(props);
    this.state = {
      showLanesPopup: false,
      editData: [],
      ammendmentId: [],
      
    }
  }


  checkAllAmmendment = ()=> {
    const {ammendmentData} = this.props;
    let ammendmentId = [];
    if(ammendmentData.length !== this.state.ammendmentId.length){
      ammendmentData.map(el => {
        ammendmentId.push(el.ammendmentId);
      })
    }
    this.setState({
        ammendmentId
    })
  }

  setShowLanesPopup = (value = []) => {
    const {showLanesPopup} = this.state;
    this.setState({
      showLanesPopup: !showLanesPopup,
      editData: value
    })
    }

  ammendmentSelect = (e, Id) => {
    const {ammendmentId} = this.state;
    if(e.target.checked){
      ammendmentId.push(Id);
    }else{
      ammendmentId.splice(ammendmentId.indexOf(Id),1);
    }
    this.setState({
      ammendmentId
    })
  }

  approveRejectAmmendment = (approvalStatus) => {
    const {ammendmentId} = this.state;
    const user = getUser();
    const data = {
      approvalStatus,
      ammendmentId,
      approvalLevel: user.ammendmentLevel,
      approvedBy: user.userId
    };
    this.props.approveRejectAmmendment(data)
  }


  render() {
    const { status, ammendmentData, count } = this.props;
    const {ammendmentId} = this.state;
    console.log(ammendmentData)
    return (
      <div className="approval-dashboard">
        <div className="fluid-container ml-20">
          <div className="box-shadow br-5 pl-15 pr-15 pt-15 pb-15 mt-20 ml-40 ">
            <div className="flex flex-middle flex-between mb-30">
              {status === 20 && (
                <div className="fBold fs-22 rfq-table-title pl-10 pt-20 pb-20 header-medium-color">
                  Ammendment Approval List
                </div>
              )}
              {status === 21 && (
                <div className="fBold fs-22 rfq-table-title pl-10 pt-20 pb-20 header-medium-color">
                  Approved List
                </div>
              )}
              {status === 22 && (
                <div className="fBold fs-22 rfq-table-title pl-10 pt-20 pb-20 header-medium-color">
                  Rejected List
                </div>
              )}
              <div className="flex flex-middle"></div>
            </div>

            <div className="flex flex-between mb-20 pr-30">
              
                {status === 20 && (
                  <Checkbox type="square" onCheck={this.checkAllAmmendment} checked={ammendmentId.length > 0 && (ammendmentId.length === ammendmentData.length)}/>
                )}
              <div className="fBold fs-16 header-dark-color col-4 pl-15">
              AR No. 
              </div>
              <div className="fBold fs-16 header-dark-color pl-15 wt-250">
                RFQ Name
              </div>
              <div className="fBold fs-16 header-dark-color col-4 pl-15">
                Details
              </div>
              <div className="fBold fs-16 header-dark-color col-4 pl-15">
                Remarks
              </div>
              <div className="fBold fs-16 header-dark-color col-4 pl-15">
                Raised By
              </div>
              <div className="fBold fs-16 header-dark-color col-4 pl-40">
                Raised On
              </div>
            </div>
            {this.getBody(status)}
          </div>
        </div>
        {(status === 20 && ammendmentId.length > 0) ? 
          <div className={"pf box-shadow ht-60 bg-white b-0 col-1 z-300"}>
            <div className="container flex col-9 flex-middle flex-between row-100 pl-300">
              <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={() => this.approveRejectAmmendment("APPROVED") }>Approve</button>
              <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={() => this.approveRejectAmmendment("REJECTED") }>Reject</button>
            </div>
          </div>: null
        }
      </div>
    );
  }
  
  getBody(status) {
    const { ammendmentData } = this.props;
    const { showLanesPopup, editData, ammendmentId } = this.state;
    return (
      <Fragment>
        {ammendmentData.length > 0 ? (
          <Fragment>
            {" "}
            {ammendmentData.map((val) => (
              <div className="rfq-row pr flex flex-between flex-middle border-top-light pt-25 pb-25 pr-10 bg-hover-light curP">
                <div className="fs-14 table-text-color col-8 pl-15">
                  {status === 20 && <input type="checkbox" checked={ammendmentId.includes(val.ammendmentId)} onClick={e => this.ammendmentSelect(e,val.ammendmentId)}/>} 
                  {val.ammendmentNumber}
                </div>
                <div className="fs-14 table-text-color col-8 pl-15">
                {val.rfqName}
                </div>
                <div className="fs-14 table-text-color col-9 pl-15">
                  <span
                    className="curP"
                    onClick={ () => this.setShowLanesPopup(val)}
                    style={{
                      color: "white",
                      fontSize: "12px",
                      fontWeight: "900",
                      padding: "5px 10px",
                      borderRadius: "50%",
                      backgroundColor: "#548bea",
                    }}>{" "}i{" "}
                  </span>
                  {showLanesPopup &&
                    <DetailsPopup
                        setShowLanesPopup={this.setShowLanesPopup}
                        laneData={editData}
                    />
                  }
                </div>
                <div className="fs-14 table-text-color col-9 pl-15">
                  Remarks
                </div>
                <div className="fs-14 table-text-color col-6 pl-15 fs-14 lh-15p">
                  {val.updatedBy}
                </div>
                <div className="fs-14 table-text-color col-9 fs-14 lh-15p wt-100 pr-20">
                  {val.createdOn !== undefined && val.createdOn !== 0 && moment(val.createdOn).format("DD-MM-YYYY")}
                </div>
              </div>
            ))}
          </Fragment>
        ) : (
          <div className="fBold fs-14 caption-color pl-5 mt-50 mb-20 tCenter">No Data Found</div>
        )}
        
      </Fragment>
    );
  }

 
}
